module.exports = __webpack_public_path__ + "img/Club-slider2-Eventst.38e942d1.png";